<template>
  <div>
    <az-back-button
      :route="{name: 'licitacao', params: {id: licitacaoId}, query: {edicao: true}}"
      text="Voltar para a licitação">
    </az-back-button>
    <az-container>
      <licitacao-atualizacao-acoes :ocorrencia="true"></licitacao-atualizacao-acoes>
      <div class="az-form-content">
        <v-data-table
          :headers="headers"
          :items="historicos"
          hide-actions
          class="elevation-0"
          no-data-text="Nenhum Historico encontrado."
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.loteDescricao }}</td>
              <td>
                <expandir-texto :texto="codigoDescricao(props.item)" tamanho="50"></expandir-texto>
              </td>
              <td>{{ descricaoTipoOcorrencia(props.item.tipoOcorrencia) }}</td>
              <td>{{ props.item.numeroProtocolo }}</td>
              <td>
                <expandir-texto :texto="props.item.justificativa" tamanho="50"></expandir-texto>
              </td>
              <td class="text-xs-center">
                <v-icon
                  small
                  color="grey"
                  class="clickable"
                  @click="abrirModalCancelamento(props.item.historicoId)"
                >
                  cancel
                </v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>

        <div class="az-actions-form" slot="actions">
          <div class="align-left">
            <button class="action-secundary" @click="voltarParaLicitacao">CANCELAR</button>
          </div>
        </div>

        <v-dialog v-model="mostrarModalCancelamento" persistent max-width="500">
          <v-card style="border-radius: 16px">
            <v-card-text style="text-align: center; display: flex; flex-direction: column; align-items: center; gap: 16px;">
              <v-icon class="icon-alert-pncp" color="orange" aria-hidden="true" style="font-size: 81px;">warning</v-icon>

              <p style="font-size: 24px; font-weight: bold; margin: 0; color: #696868">
                Atenção! Você está prestes a cancelar o envio da Ocorrência
              </p>

              <p style="margin: 0; font-size: 18px; color: #7a7979;">
                Após a confirmação os dados enviados serão cancelados!
              </p>

              <p style="margin: 0; font-size: 18px; color: #7a7979;">
                Deseja realmente confirmar esta ação?
              </p>
            </v-card-text>

            <v-card-actions style="justify-content: center; padding: 16px; gap: 16px;">
              <button
                class="btn cancel btn-excluir"
                @click="fecharModalCancelamento"
              >
                NÃO
              </button>
              <button
                class="btn submit btn-excluir"
                @click="confirmarCancelamentoOcorrencia"
              >
                SIM
              </button>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </az-container>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {actionTypes, tiposOcorrenciaLicitacao} from '@/commons/constants'
import LicitacaoAtualizacaoAcoes from './LicitacaoAtualizacaoAcoes.vue'
import ExpandirTexto from '@/commons/components/ExpandirTexto.vue'

export default {
  name: 'LicitacaoAtualizacaoAcoesOcorrenciasEnviar',
  components: {ExpandirTexto, LicitacaoAtualizacaoAcoes},
  created() {
    this.buscarLicitacao(this.$route.params.id)
    this.carregarHistoricosOcorrenciaEsfinge(this.$route.params.id)
  },
  data() {
    return {
      licitacaoId: this.$route.params.id,
      tiposOcorrenciaLicitacao,
      historicoId: null,
      headers: [
        { text: 'Tipo', value: 'tipo', width: '100px', sortable: false },
        { text: 'Código/Descrição', value: 'codigoDescricao', sortable: false },
        { text: 'Tipo Ocorrência', value: 'tipoOcorrencia', sortable: false },
        { text: 'Nº Protocolo', value: 'numeroProtocolo', sortable: false },
        { text: 'Justificativa', value: 'justificativa', sortable: false },
        { text: 'Ações', value: 'acoes', width: '20px', sortable: false, class: 'text-xs-center' }
      ],
      historicos: [],
      mostrarModalCancelamento: false,
    }
  },
  computed: {
    ...mapState(["licitacao"])
  },
  methods: {
    abrirModalCancelamento(historicoId) {
      this.historicoId = historicoId
      this.mostrarModalCancelamento = true;
    },
    async carregarHistoricosOcorrenciaEsfinge(licitacaoId) {
      const data = await this.buscarHistoricosOcorrenciaEsfinge(licitacaoId)
      this.historicos = data.historicos
    },
    confirmarCancelamentoOcorrencia() {
      this.excluirOcorrencia({
        licitacaoId: this.licitacaoId,
        historicoId: this.historicoId
      }).then(response => {
        if (response.error) {
          this.mostrarNotificacaoErro(response.message)
        } else {
          this.mostrarNotificacaoSucessoDefault()
        }
      }).finally(() => {
        this.fecharModalCancelamento()
      })
    },
    codigoDescricao(item) {
      return item.itemCodigo && item.itemDescricao
        ? `${item.itemCodigo} - ${item.itemDescricao}`
        : '--'
    },
    converterEnumParaSelect(enumArray) {
      return enumArray.map(item => ({
        valor: Array.isArray(item.codigo) ? item.codigo[0] : item.codigo,
        texto: item.texto
      }));
    },
    fecharModalCancelamento() {
      this.mostrarModalCancelamento = false;
    },
    descricaoTipoOcorrencia(tipoOcorrencia) {
      const codigo = Number(tipoOcorrencia)
      const ocorrencia = tiposOcorrenciaLicitacao.find(item => {
        if (Array.isArray(item.codigo)) {
          return item.codigo.includes(codigo)
        }
        return item.codigo === codigo
      })
      if (Array.isArray(ocorrencia.codigo)) {
        if (codigo === 3)
          return 'Fracassada'
        if (codigo === 4)
          return 'Deserta'
      }
      return ocorrencia.texto
    },
    voltarParaLicitacao() {
      this.$router.push( { name: 'licitacao', params: {id: this.licitacaoId}, query: {edicao: true} })
    },
    ...mapActions([
      actionTypes.BUSCAR_LICITACAO,
      actionTypes.BUSCAR_HISTORICOS_OCORRENCIA,
      actionTypes.EXCLUIR_OCORRENCIA])
  }
}
</script>